/*jshint esversion: 6 */
import httpClient from './httpClient.js';

function URL() {
  if (process.env.NODE_ENV == "development")
    return window.location.protocol + "//" + window.location.hostname + ":8008";

  return (
    window.location.protocol +
    "//" +
    window.location.hostname +
    ":" +
    window.location.port
  );
}

function wsURL() {
  var protocol;

  if (window.location.protocol == "https:") protocol = "wss:";
  else protocol = "ws:";

  if (process.env.NODE_ENV == "development")
    return protocol + "//" + window.location.hostname + ":8008";

  return (
    protocol + "//" + window.location.hostname + ":" + window.location.port
  );
}

function header() {
  return {
    headers: {
      Empresa: getEmp(),
    },
  };
}

function getEmp() {
    let urlParams = new URLSearchParams(window.location.search);
    let empresa = urlParams.get('e');
    
    if (!empresa) empresa = 1;

    return empresa;
}

// Funció per fer peticions amb gestió automàtica d'errors
async function apiRequest(method, url, data = null, config = {}) {
  const fullUrl = URL() + url;
  const requestConfig = {
    method,
    url: fullUrl,
    ...config
    // No cal afegir headers aquí, ja els gestiona httpClient via interceptors
  };

  if (data) {
    requestConfig.data = data;
  }

  try {
    const response = await httpClient.request(requestConfig);
    return response;
  } catch (error) {
    console.error(`Error en petició ${method} ${url}:`, error);
    throw error;
  }
}

export default {
  URL,
  wsURL,
  header,
  getEmp,
  apiRequest,
  // Mètodes de conveniència
  get: (url, config = {}) => apiRequest('GET', url, null, config),
  post: (url, data, config = {}) => apiRequest('POST', url, data, config),
  put: (url, data, config = {}) => apiRequest('PUT', url, data, config),
  delete: (url, config = {}) => apiRequest('DELETE', url, null, config),
  
  // Mètode especialitzat per validar tokens amb gestió d'errors adequada
  validateToken: async (token) => {
    try {
      const response = await apiRequest('POST', '/api/v1/token', { token });
      return {
        isValid: response.data === "OK",
        isConnectionError: false,
        error: null
      };
    } catch (error) {
      console.log("Token validation error:", error);
      
      // Determinar si és un error de connexió o un token invàlid
      let isConnectionError = false;
      
      if (!error.response) {
        // Error de xarxa o timeout
        isConnectionError = true;
      } else if (error.response.status >= 500) {
        // Error del servidor
        isConnectionError = true;
      } else if (error.response.status === 401 || error.response.status === 403) {
        // Error d'autorització - token invàlid
        isConnectionError = false;
      } else {
        // Altres errors HTTP - tractar com problemes de connexió
        isConnectionError = true;
      }
      
      return {
        isValid: false,
        isConnectionError,
        error: error
      };
    }
  }
};
